import { render } from "./InvestorTable.vue?vue&type=template&id=d305a622&scoped=true"
import script from "./InvestorTable.vue?vue&type=script&lang=js"
export * from "./InvestorTable.vue?vue&type=script&lang=js"

import "./InvestorTable.vue?vue&type=style&index=0&id=d305a622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d305a622"]])

export default __exports__